import { render, staticRenderFns } from "./preliminaryReviewOfLoansList.vue?vue&type=template&id=5f8a0274&scoped=true&"
import script from "./preliminaryReviewOfLoansList.vue?vue&type=script&lang=js&"
export * from "./preliminaryReviewOfLoansList.vue?vue&type=script&lang=js&"
import style0 from "./preliminaryReviewOfLoansList.vue?vue&type=style&index=0&id=5f8a0274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8a0274",
  null
  
)

export default component.exports